import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body, Container, CustomButton, Text, Title, Wrapper } from './styled';

interface IPageLayout {
  buttonText?: string;
  children?: React.ReactNode;
  className?: string;
  icon: React.ReactElement;
  onClick?: () => void;
  subtitle: string;
  title: string;
}

const WrongPageLayout: React.FC<IPageLayout> = ({
  buttonText,
  children,
  className,
  icon,
  onClick,
  subtitle,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper className={className}>
      <Container>
        <Body>
          {icon}
          <Title size='xxl' variant='regular'>
            {title}
          </Title>
          <Text size='sm' variant='regular'>
            {subtitle}
          </Text>
          {children || (
            <CustomButton onClick={onClick} variant='primary'>
              {buttonText || t('common.goHomeButton')}
            </CustomButton>
          )}
        </Body>
      </Container>
    </Wrapper>
  );
};

export default WrongPageLayout;
